const processRiskCounts = (processStats) => {
  const counts = {}
  ;(processStats?.departments || []).forEach((department) => {
    Object.entries(department.risks || {}).forEach(([riskName, count]) => {
      counts[riskName] = (counts[riskName] || 0) + count
    })
  })
  return counts
}

export default processRiskCounts
